//Charge viewer
export const CHARGE_VIEWER_REQUEST = "CHARGE_VIEWER_REQUEST";
export const CHARGE_VIEWER_RECEIVE = "CHARGE_VIEWER_RECEIVE";
export const CHARGE_VIEWER_FAILURE = "CHARGE_VIEWER_FAILURE";
export const RESET_CHARGE_VIEWER = "RESET_CHARGE_VIEWER";